import { Navigate } from "react-router-dom";
import { isMobileLike } from "../lib/isMobile";
import { isJulyupayApp } from "../lib/openExternal";
import JulyHome from "../components/design/JulyHome";
export default function Home() {
  if (isJulyupayApp() || isMobileLike()) return <Navigate to="/m/home" replace />;
  return <JulyHome />;
}
